<template>
	<LayoutList>
		<template slot="header">
			<h1>Assume Identity</h1>
		</template>

		<template slot="filters">
			<FormControlSector name="sectors" v-model="filters.sectors" :multiple="true" :include-ancestors="false">
			</FormControlSector>
			<FormControlMember name="member" v-model="filters.member" placeholder="Select..."></FormControlMember>
		</template>

		<input slot="search" class="form__control" type="search" placeholder="Search Users..."
		       v-model="filters.query" />

		<ListUsers ref="all" :filters="filters" :show-impersonate="true"></ListUsers>
	</LayoutList>
</template>

<script>
	import LayoutList from '../Layout/LayoutList';
	import ListUsers from '../List/ListUsers';
	import FormControlSector from '../Form/Control/FormControlSector';
	import FormControlCategory from '../Form/Control/FormControlCategory';
	import FormControlMember from '../Form/Control/FormControlMember';

	export default {
		name: 'UserImpersonate',
		components: {
			FormControlMember,
			FormControlCategory,
			FormControlSector,
			ListUsers,
			LayoutList,
		},
		data() {
			return {
				filters: {
					sectors: [],
					member: null,
					query: null,
				},
			}
		},
	}
</script>
